// Queue Manager utility for localStorage-based queue management
const QueueManager = {
    // Check if data is from same day
    isSameDay(timestamp) {
        const today = new Date().toLocaleDateString('no-NO', { timeZone: 'Europe/Oslo' });
        const dataDate = new Date(timestamp).toLocaleDateString('no-NO', { timeZone: 'Europe/Oslo' });
        return today === dataDate;
    },

    // Store queue data in localStorage
    setQueue(ticketCode, queueData) {
        const dataWithTimestamp = {
            ...queueData,
            timestamp: Date.now(),
        };

        try {
            localStorage.setItem(
                `queue_${ticketCode}`,
                JSON.stringify(dataWithTimestamp)
            );
            console.log("📱 Queue stored in localStorage:", dataWithTimestamp);
            return true;
        } catch (error) {
            console.warn("⚠️ Failed to store in localStorage:", error);
            return false;
        }
    },

    // Get queue data from localStorage
    getQueue(ticketCode) {
        console.log("🔍 Looking for queue data for ticket:", ticketCode);

        try {
            const localData = localStorage.getItem(`queue_${ticketCode}`);
            if (localData) {
                const data = JSON.parse(localData);
                if (this.isSameDay(data.timestamp)) {
                    console.log("📱 Queue found in localStorage:", data);
                    return data;
                } else {
                    console.log("📱 localStorage data is old, removing...");
                    localStorage.removeItem(`queue_${ticketCode}`);
                }
            }
        } catch (error) {
            console.warn("⚠️ Failed to read from localStorage:", error);
        }

        console.log("❌ No queue data found");
        return null;
    },

    // Update queue data
    updateQueue(ticketCode, queueData) {
        const existingData = this.getQueue(ticketCode);
        const updatedData = {
            ...existingData,
            ...queueData,
            timestamp: Date.now(),
        };

        return this.setQueue(ticketCode, updatedData);
    },

    // Clear queue data
    clearQueue(ticketCode) {
        console.log("🗑️ Clearing queue data for ticket:", ticketCode);

        try {
            localStorage.removeItem(`queue_${ticketCode}`);
            console.log("✅ Queue data cleared successfully");
            return true;
        } catch (error) {
            console.warn("⚠️ Failed to clear localStorage:", error);
            return false;
        }
    },

    // Check if queue exists
    hasQueue(ticketCode) {
        const data = this.getQueue(ticketCode);
        return data !== null;
    },

    // Get all queue keys (for debugging)
    getAllQueueKeys() {
        const keys = [];
        for (let i = 0; i < localStorage.length; i++) {
            const key = localStorage.key(i);
            if (key && key.startsWith("queue_")) {
                keys.push(key);
            }
        }
        return keys;
    },

    // Clear all queue data (for cleanup)
    clearAllQueues() {
        const keys = this.getAllQueueKeys();
        keys.forEach((key) => {
            localStorage.removeItem(key);
        });
        console.log(`🗑️ Cleared ${keys.length} queue entries`);
    },
};

export default QueueManager;
